/* eslint-disable max-classes-per-file */
export class MattslagRequest implements IMattslagRequest {
    marknadsomradeId: number;
    resultatomradeId: number;
    mattslagId: number;
    marknadsomradeNamn: string;
    resultatomradeNamn: string;
}
export class MattslagSaveRequest {
    marknadsomradeId: number; // string i IMattslagSaveRequest?
    resultatomradeId: number;
    mattslagId: number;
    mattslagskonverteringar: IMattslagskonvertering[];
}

export interface IMattslagskonverteringBasData {
    marknadsomraden: IMarknadsomrade[];
    resultatomraden: IResultatomrade[];
    mattslagList: IMattslag[];
}

export interface IMattslag {
    id: number;
    kod: number;
    kortnamn: string;
}

export interface IResultatomrade {
    id: number;
    marknadsomradeId: number;
    namn: string;
}

export interface IMarknadsomrade {
    id: number;
    namn: string;
}

export interface IMattslagRequest {
    marknadsomradeId: number;
    resultatomradeId: number;
    mattslagId: number;
}
export interface IMattslagSaveRequest {

    marknadsomradeId: string;
    resultatomradeId: number;
    mattslagId: number;
    mattslagskonverteringar: IMattslagskonvertering[];
}

export interface IMattslagResponse {

    marknadsomradeId: number;
    resultatomradeId: number;
    mattslagId: number;
    mattslagskonverteringar: IMattslagskonvertering[];
}

export interface IMattslagskonvertering {
    produktgruppId: number;
    produktgrupp: string;
    perioder: IPeriod[];
}

export interface IPeriod {
    inherited: boolean;
    konverteringsFaktor: number;
    manadNummer: number;
    tooltip: string;
    standardVardeOnSave: boolean;
    invalid: boolean;
}

export interface ITableChangeData {
    row: any;
    prop: any;
    oldVal: any;
    newVal: any;
    cell: any;
    deleteData: boolean;
    invalid: boolean;
}

export interface IRenderData {
    mattslag: IMattslagskonvertering;
    period: IPeriod;
}

export interface IEditingData {
    marknadsomradeId: number;
    resultatomradeId: number;
    mattslagId: number;
}
